/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerFindAllQueryResponse, InvitationsControllerFindAllQueryParams, InvitationsControllerFindAll401, InvitationsControllerFindAll403 } from "../../models/invitationsController/InvitationsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { invitationsControllerFindAll } from "../../clients/invitationsService/invitationsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const invitationsControllerFindAllQueryKey = (params: InvitationsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/invitations'
}, ...(params ? [params] : [])] as const;
export type InvitationsControllerFindAllQueryKey = ReturnType<typeof invitationsControllerFindAllQueryKey>;
export function invitationsControllerFindAllQueryOptions(params?: InvitationsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = invitationsControllerFindAllQueryKey(params);
  return queryOptions<InvitationsControllerFindAllQueryResponse, ResponseErrorConfig<InvitationsControllerFindAll401 | InvitationsControllerFindAll403>, InvitationsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return invitationsControllerFindAll(params, config);
    }
  });
}

/**
 * @description Retrieves a paginated list of invitations. Results are filtered based on user permissions.
 * @summary List invitations
 * {@link /api/v1/invitations}
 */
export function useInvitationsControllerFindAll<TData = InvitationsControllerFindAllQueryResponse, TQueryData = InvitationsControllerFindAllQueryResponse, TQueryKey extends QueryKey = InvitationsControllerFindAllQueryKey>(params?: InvitationsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<InvitationsControllerFindAllQueryResponse, ResponseErrorConfig<InvitationsControllerFindAll401 | InvitationsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? invitationsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...invitationsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<InvitationsControllerFindAll401 | InvitationsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}